import { TYPE_LABELS } from 'lib/constants/transaction/typeLabels';
import { Capitalize, calculateAge, cn, formatDate } from 'lib/helpers/utility';

import InfoItem from 'components/practice/BeyondBilling/ElectronicInvoicing/components/Invoice/components/InvoiceHeader/InfoItem';
import { getAddressDisplay } from 'components/practice/BeyondBilling/ElectronicInvoicing/components/Invoice/lib/helpers';
import Dot from 'components/shared/Dot/Dot';

const PatientInformation = ({ patient, transaction, lowercase = false }) => {
  const lowerCaseClassName = lowercase ? '' : 'capitalize';

  return (
    <div className="flex min-h-36 px-2 py-3 md:px-6">
      <div className="flex flex-1 flex-col">
        <InfoItem value="Billed To" color="neutral-500" className={lowerCaseClassName} />
        <InfoItem value={patient?.f_name + ' ' + patient?.l_name} />
        <div className="flex flex-row flex-wrap items-center gap-1">
          {patient?.id && <InfoItem value={`#${patient?.id}`} color="neutral-700" />}
          {patient?.dob && patient?.id && <Dot size="xs" color="neutral" />}
          {patient?.dob && (
            <>
              <InfoItem value={formatDate(patient?.dob)} color="neutral-700" />
              <Dot size="xs" color="neutral" />
              <InfoItem
                value={`(${calculateAge({ dateOfBirth: patient?.dob })} years)`}
                color="neutral-700"
              />
            </>
          )}
        </div>
        <InfoItem value={getAddressDisplay(patient?.userAddress)} />
        <InfoItem value={patient?.phone} color="neutral-700" />
        <InfoItem value={patient?.email} color="neutral-700" />

        <div className="flex flex-col pt-3">
          <InfoItem value="Payment Method" color="neutral-500" className={lowerCaseClassName} />
          <InfoItem
            value={TYPE_LABELS[transaction?.type] ?? Capitalize(transaction?.type)}
            color="neutral-700"
          />
        </div>
      </div>
      <div className="flex flex-col items-end gap-3">
        <div className="flex flex-col items-end">
          <InfoItem value="Transaction ID" color="neutral-500" className={lowerCaseClassName} />
          <InfoItem value={transaction?.id} color="neutral-700" />
        </div>
        <div className="flex flex-col items-end">
          <InfoItem
            value="Transaction Date & Time"
            color="neutral-500"
            className={lowerCaseClassName}
          />
          <InfoItem value={formatDate(transaction?.created_at)} color="neutral-700" />
        </div>
        <div className={cn('flex flex-col items-end', !transaction?.dateOfService && 'opacity-0')}>
          <InfoItem value="Date of Service" color="neutral-500" className={lowerCaseClassName} />
          <InfoItem value={formatDate(transaction?.dateOfService)} color="neutral-700" />
        </div>
      </div>
    </div>
  );
};

export default PatientInformation;
